<template>
	<div class="time-num">
		<div class="box">
			<div class="tiems">
				<img src="./../../assets/home/times.png" alt="" srcset="" />
				<div class="num">{{ countDownText }}</div>
			</div>
			<div class="status">
				<img @click="handleContinueExam" v-if="isPause" src="./../../assets/home/start.png" alt="" srcset="" />
				<img @click="handlePause" v-if="!isPause" src="./../../assets/home/stop.png" alt="" srcset="" />
			</div>
		</div>
		<!-- 暂停 -->
		<div class="zantingbox" v-show="isPause">
			<div class="main">
				<img src="./../../assets/home/zt1.png" />
				<div class="zantingbox-suspend">考核暂停中</div>
				<div class="zantingbox-opportunity">
					您共有 <span>{{ allPauseCount }}</span> 次考核暂停的机会当前第
					<span>{{ allPauseCount - pauseCount }}</span> 次，剩余
					<span> {{ pauseCount }}</span> 次
				</div>
				<div class="btn" @click="handleContinueExam">继续考核</div>
			</div>
		</div>
		<!-- 时间结束 -->
		<div class="page-mouthModal" v-show="visible">
			<div class="content">
				<div class="title">提示！</div>
				<div class="text">
					<p>考试时间已结束，点击"确定"获得成绩。</p>
				</div>
				<div class="footer">
					<button @click="handleOk">确定</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		mapState,
		mapMutations
	} from "vuex";
	import {
		submitSlideAnswer,
		submitPetAnswer
	} from "@/api/system/exam";
	import {
		examPauseExam,
		examRestartExam
	} from "../../api/system/exam";
	export default {

		data() {
			return {
				mixinIsErrorShow: false,
				routerNum: null,
				// isPause: false, // 是否暂停
				allPauseCount: 2, // 总暂停次数
				pauseCount: 2, // 当前暂停次数
				countDownTime: 3600, // 初始化为1小时（60分钟）
				countDownText: "00:00", // 倒计时文案
				timesMicroscope: null,
				visible: false,
				// 1显微镜  2考核
				// activeIndex: 1,
				activeRoute: null,
				timesTreat: null,
			};
		},
		mounted() {
			this.countDownTime = this.microscopeTimeNum;
			this.allPauseCount = this.stateAllPauseCount;
			this.pauseCount = this.statePauseCount;
			this.downtimer(true);


		},
		destroyed() {
			clearInterval(this.timesMicroscope);
		},
		computed: {
			...mapState("visualExamination", [
				//步骤二
				"detail",
				//步骤三
				"detailsz2",
				//步骤四
				"detail3",
				"detailstepPre3",
				//步骤五
				"detail4",
				//步骤六
				"detail5",
				//倒计时
				"treatModleTime",
				"treatmentList",
			]),
			...mapState("microscope", [
				"slidePaper",
				"detail1",
				"detail2",
				"microscopeModleTime",
				"microscopeTimeNum",
				"activeIndex",
				"stateAllPauseCount",
				"statePauseCount",
				"isPause",
			]),
		},
		methods: {
			...mapMutations("microscope", ["handleMicroscope"]),
			downtimer(isTimer) {
				this.coundDown();
				if (!isTimer) return;
				if (this.isPause) return
				this.timesMicroscope = setInterval(() => {
					this.countDownTime--;
					this.handleMicroscope({
						key: "microscopeTimeNum",
						value: this.countDownTime,
					});
					if (this.countDownTime < 0) {
						this.visible = true;
						clearInterval(this.timesMicroscope);
						// 在这里要自动提交试卷
						return;
					}
					this.coundDown();
				}, 1000);
			},
			coundDown() {
				const minutes = Math.floor(this.countDownTime / 60);
				const seconds = this.countDownTime % 60;
				this.countDownText = `${minutes.toString().padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")}`;
			},
			// 暂停
			handlePause() {
				if (this.pauseCount <= 0) {
					this.$toast({
						message: "您已没有暂停次数，请继续作答。",
					});
					return;
				} // 没有暂停机会
				// 暂停完成次数-1，并且设置为暂停中
				this.pauseCount--;
				// this.isPause = true;
				this.handleMicroscope({
					key: "statePauseCount",
					value: this.pauseCount,
				});
				this.handleMicroscope({
					key: "isPause",
					value: true,
				});
				clearInterval(this.timesMicroscope);
				examPauseExam().then((response) => {
					if (response.data.data) {

					} else {
						this.$toast({
							message: "您已没有暂停次数，请继续作答。",
						});
						return;
					}
				});
			},
			// 继续考试
			handleContinueExam() {
				examRestartExam().then((response) => {
					if (response.data.data) {
						//this.isPause = false;
						this.handleMicroscope({
							key: "isPause",
							value: false,
						});
						this.downtimer(true);
					} else {
						this.$toast({
							message: "开始失败！",
						});
						return;
					}
				});

			},
			//关闭弹框
			handleOk() {
				this.visible = false;
				if (this.activeIndex === 1) {
					let data = {
						paper1Id: this.slidePaper[0].id,
						paper2Id: this.slidePaper[1].id,
						detail1: this.detail1,
						detail2: this.detail2,
					};
					submitSlideAnswer(data).then((res) => {
						if (res.data.code === 0) {
							// this.activeIndex = 1;
							this.$router.replace("/treat/assemble");
						}
					});
				} else if (this.activeIndex === 2) {
					//每一步骤的最后答题结果
					const treatmentLists = this.treatmentList

					let newArr = [
						...this.detail,
						...this.detailsz2,
						...this.detail3,
						...this.detailstepPre3,
						...this.detail4,
						...this.detail5,
					];
					newArr = newArr.filter((v) => v !== []);
					const parmes = {
						paperId: treatmentLists.id,
						details: newArr,
					};
					submitPetAnswer(parmes).then((res) => {
						if (res.data.code === 0) {
							this.$router.replace("/treat/assemble");
						}
					});
				}
			},
		},
	};
</script>

<style lang="less" scoped>
	.time-num {
		padding: 10px 40px;

		.box {
			display: flex;
			align-items: center;

			.tiems {
				position: relative;
				display: flex;
				align-items: center;

				img {
					width: 160px;
					height: 64px;
				}

				.num {
					position: absolute;
					left: 70px;
					left: 64px;
					font-size: 28px;
					font-weight: 400;
					color: rgba(4, 56, 131, 1);
				}
			}

			.status {
				margin-left: auto;

				img {
					width: 56px;
				}
			}
		}

		.zantingbox {
			position: fixed;
			width: 100%;
			height: 100%;
			z-index: 11;
			top: 0;
			left: 0;
			background: rgba(0, 0, 0, 0.7);

			.main {
				width: 550px;
				height: 700px;
				border-radius: 50px;
				background: rgba(255, 255, 255, 1);
				margin: 340px auto 0;
				display: flex;
				flex-direction: column;
				align-items: center;

				img {
					width: 273px;
					height: 197px;
					margin-top: 90px;
				}

				.zantingbox-suspend {
					width: 100%;
					text-align: center;
					margin-top: 30px;
					font-size: 44px;
					font-weight: 400;
					color: rgba(51, 51, 51, 1);
				}

				.zantingbox-opportunity {
					width: 370px;
					text-align: center;
					margin: 25px auto 0;
					font-size: 30px;
					font-weight: 400;
					color: rgba(51, 51, 51, 1);

					span {
						color: rgba(247, 31, 31, 1);
						margin: 0 10rpx;
					}
				}

				.btn {
					width: 350px;
					height: 98px;
					border-radius: 49px;
					margin-top: 60px;
					background: linear-gradient(138.51deg,
							rgba(0, 187, 177, 1) 0%,
							rgba(0, 80, 137, 1) 79.86%,
							rgba(171, 59, 127, 1) 100%);
					font-size: 34px;
					font-weight: 400;
					color: rgba(255, 255, 255, 1);
					text-align: center;
					line-height: 98px;
				}
			}
		}

		.page-mouthModal {
			width: 100%;
			min-height: 100vh;
			position: absolute;
			left: 0;
			top: 0;
			background: rgba(#fff, 0.8);
			display: flex;
			align-items: center;
			z-index: 9999;
			padding: 0px 40px;
			box-sizing: border-box;

			.content {
				width: 100%;
				height: 642px;
				z-index: 999;
				background: #ffffff;
				background: rgba(255, 255, 255, 0.9);
				border: 2px solid #ffffff;
				border-radius: 60px;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				// padding-top: 90px;
				// padding-bottom: 77px;
			}

			.title {
				font-size: 65px;
				font-family: HarmonyOS Sans SC;
				font-weight: bold;
				color: #ab3b91;
			}

			.text {
				font-size: 35px;
				font-family: HarmonyOS Sans SC;
				font-weight: bold;
				color: #333333;
				line-height: 60px;
				margin-top: 80px;
				text-align: center;
			}

			.footer {
				margin-top: 110px;

				button {
					width: 262px;
					height: 79px;
					background: linear-gradient(90deg, #1e3c72, #2a5298);
					border: 1px solid #ffffff;
					box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
					text-align: center;
					font-size: 35px;
					font-family: HarmonyOS Sans SC;
					font-weight: 500;
					color: #ffffff;
					line-height: 60px;
					letter-spacing: 2px;
					border-radius: 40px;
				}

				button:nth-child(2) {
					margin-left: 42px;
				}
			}
		}
	}
</style>